import { Component, Input } from '@angular/core';
import { ChecksComponent } from '../../../../../processes/components/checks/checks.component';
import { CHECK, IProcessDetailResponse } from '../../../../../processes/models/processes.models';

/**
 * Contraste de información OCR (MRZ, AEAT, AML, PEP) en comprobaciones de detalle de operación.
 */
@Component({
	selector: 'app-operation-ocr-checks-compare-info',
	imports: [ChecksComponent],
	templateUrl: './operation-ocr-checks-compare-info.component.html',
	styleUrl: './operation-ocr-checks-compare-info.component.scss',
})
export class OperationOcrChecksCompareInfoComponent {
	@Input({ required: true }) checksDetail!: IProcessDetailResponse;
	/** Comprobaciones adicionales en Contraste (p. ej. KO 2014 match_data en OCR sin tile FORM). */
	@Input() extraChecks: CHECK[] = [];

	protected readonly baseChecks: CHECK[] = [CHECK.READ_MRZ, CHECK.AEAT, CHECK.AML, CHECK.PEP];

	protected get checks(): CHECK[] {
		return [...this.baseChecks, ...this.extraChecks];
	}
}
